import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[invClass]',
})
export class InvClassDirective {
    constructor(private el: ElementRef) {}

    private _isValid: boolean = true;

    @Input() set isValid(value: boolean) {
        this._isValid = value;
        this.setClass();
    }

    get isValid(): boolean {
        return this._isValid;
    }

    setClass() {
        this._isValid
            ? this.el.nativeElement.classList.remove('k-invalid')
            : this.el.nativeElement.classList.add('k-invalid');
    }
}
